import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';
import PrincipalIsPG from '../rules/PrincipalIsPG';
import IsASAPCountEqualToZero from '../rules/IsASAPCountEqualToZero';
import RelatedPartyRelationshipEqualsTo from '../rules/RelatedPartyRelationshipEqualsTo';
import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';

class ApplicantSameAsPrincipalRuleset implements Ruleset {
  private principalId: any;
  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isPrincipal = RelatedPartyRelationshipEqualsTo.setRelationship(
      RELATED_PARTY_RELATIONSHIP.PRINCIPAL
    )
      .setPrincipalId(this.principalId)
      .evaluate(data);

    const isPrincipalPG = PrincipalIsPG.setPrincipalId(
      this.principalId
    ).evaluate(data);

    const isASAPCountEqualToZero = IsASAPCountEqualToZero.evaluate(data);

    const principal = data.principals?.find(
      (principal) => principal.id === this.principalId
    );
    const asapAlreadyYesForThisPrincipal =
      principal?.applicant_same_as_principal === 'Yes';
    if (
      isPrincipal &&
      isPrincipalPG &&
      (isASAPCountEqualToZero || asapAlreadyYesForThisPrincipal)
    )
      return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}
export default new ApplicantSameAsPrincipalRuleset();
